import PropTypes from 'prop-types';
import React from 'react';
import { CONSTANTS } from '../Actions/messageActions';

const MessageEmailPreviewPropType = {
  enabled: PropTypes.bool.isRequired,
  isPreventChange: PropTypes.bool,
  content: PropTypes.string,
  recipientType: PropTypes.oneOf([
    CONSTANTS.RECIPIENT_TYPE_MEMBER,
    CONSTANTS.RECIPIENT_TYPE_GROUP,
  ]),
  onSendByChange: PropTypes.func.isRequired,
};

export default MessageEmailPreviewPropType;
